import React, { Component } from "react";
import AntdTransfer, {TransferProps} from 'antd/lib/transfer';
import 'antd/lib/transfer/style';

export default class Transfer extends Component<TransferProps> {
    render() {
        return (
          <AntdTransfer {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/transfer/index.tsx